import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import welcomeImage from "../../../assets/images/icons/dome-logo.svg";
import { GeneralButton, Modal } from "../../../components";

function WelcomeModal() {
  const [modelOpen, setModelOpen] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    const hasSeenModal = localStorage.getItem("hasSeenModal");
    if (!hasSeenModal) {
      setModelOpen(true);
      localStorage.setItem("hasSeenModal", "true");
    }
  }, []);
  return (
    <div>
      <Modal
        headerCustomStyle="hidden"
        isOpen={modelOpen}
        customStyle="max-w-md"
        onClose={() => setModelOpen(false)}
      >
        <div className="text-center">
          <img
            src={welcomeImage}
            alt="welcome"
            className="mx-auto mb-6 w-[50%]"
          />
          <h3 className="mb-2 text-2xl font-bold">{t("welcome")}</h3>
          <p className="text-body-text mb-16 text-lg">{t("enjoy_points")}</p>
          <GeneralButton
            onClick={() => setModelOpen(false)}
            title={t("get_started")}
            className="mx-auto mb-6 !w-52 !py-2"
          />
        </div>
      </Modal>
    </div>
  );
}

export default WelcomeModal;
